import Vue from 'vue';
import QueryBuilder from '@/graphql/QueryBuilder';
import _ from 'lodash';

export var getCurentUserRoles = function() {
    let roles = Vue.ls.get('curentUserRoles');
    if( ! _.isArray(roles) ) {
        roles = undefined;
    }
    return roles;
}

export var loadCurentUserRoles = async function() {
    let qb    = new QueryBuilder();
    return qb.connection('currentUser')
        .fields('allowedPermissions {key}')
        .query().fetch().then( result => {
        let allowedPermissions = result.allowedPermissions || [];         
        return permissionsToRoles(allowedPermissions);        
    });
}

export var setCurentUserRoles = function(roles) {
    Vue.ls.get('curentUserRoles', roles);
}

export var importCurentUserRoles = async function() {
    let roles = getCurentUserRoles();
    if( ! _.isArray(roles) ) {
        roles = await loadCurentUserRoles();
        setCurentUserRoles(roles);
    }

    return roles;
}

function permissionsToRoles(permissions) {
    return permissions.map(permission => {
        return 'PERMISSION_' + permission.key.toString().toUpperCase();
    });
}


// WEBPACK FOOTER //
// ./src/helpers/user.js